const items = [
  "Psyloveyourself",
  "Ενσυναίσθηση",
  "Αποδοχή",
  "Αυτογνωσία",
  "Θεραπεία",
  "Ασφάλεια",
  "Κατανόηση",
];

export default function Marquee() {
  const loop = [...items, ...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="py-7 border-y border-border/50 overflow-hidden bg-accent/40"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {loop.map((w, i) => (
          <span
            key={i}
            className="font-heading italic text-2xl sm:text-3xl text-foreground/60 px-8 flex items-center gap-8"
          >
            {w}
            <span className="text-primary/60 not-italic">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
